import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoriesComponent } from './categories/categories.component';
import { HomeComponent } from './home/home.component';
import { PageCzujkiComponent } from './page-czujki/page-czujki.component';
import { PageDomusieComponent } from './page-domusie/page-domusie.component';
import { PageNiebyleczoComponent } from './page-niebyleczo/page-niebyleczo.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { ConfigResolve } from './shared/services/config.resolve';
import { TaskComponent } from './task/task.component';

const routes: Routes = [
  // {
  //   path: 'zrob-to-sam',
  //   loadChildren: () => import('./page-zrobtosam/page-zrobtosam.module').then(m => m.PageZrobtosamModule)
  // },
  // {
  //   path: 'slowne-historie',
  //   loadChildren: () => import('./page-word-stories/page-word-stories.module').then(m => m.PageWordStoriesModule)
  // },
  {
    path: 'czujki/:id',
    component: PageCzujkiComponent
  },
  {
    path: 'domusie/:id',
    component: PageDomusieComponent
  },
  {
    path: 'niebyleczo/:id',
    component: PageNiebyleczoComponent
  },
	{
    path: '',
    resolve: { config : ConfigResolve },
    children: [   
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }, 
      {
        path: 'home',
        component: HomeComponent,        
      },
      {
        path: 'categories',
        component: CategoriesComponent
      },
      {
        path: 'categories/:id',
        component: CategoriesComponent
      },
      {
        path: 'task/:id',
        component: TaskComponent
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
